//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { CookiesStatic } from 'js-cookie';

import { IEnumerableCognitoStorage } from './IEnumerableCognitoStorage';

// Compress/decompress Cognito Storage Key names
// so they aren't needlessly long.
const cognitoCookiePrefix = 'crl8.CISP';
function getCompressedKeyName(key: string): string {
  return key.replace(/^CognitoIdentityServiceProvider/, cognitoCookiePrefix);
}
function getFullKeyName(compressedKey: string): string {
  return compressedKey.replace(new RegExp(`^${cognitoCookiePrefix}`), 'CognitoIdentityServiceProvider');
}

/**
 * Expiration date to use for cookies.
 * LocalStorage is permanent storage, so we could go even further.
 * When this expires, a user might get logged out.
 */
const aYearFromNow: Date = (() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d;
})();

/**
 * Implements the cognito storage interface, with a backing cookie storage.
 *
 * Key names will be slightly compressed to save space.
 */
export class CompressedCookieStorage implements IEnumerableCognitoStorage {
  constructor(
        private cookieStorage: CookiesStatic,
    ) {}

  public setItem(key: string, value: string): void {
    this.cookieStorage.set(getCompressedKeyName(key), value, {
      path: '/',
      expires: aYearFromNow,
      secure: true,
    });
  }

  public getItem(key: string): string {
    return this.cookieStorage.get(getCompressedKeyName(key));
  }

  public removeItem(key: string): void {
    this.cookieStorage.remove(getCompressedKeyName(key));
  }

  public clear(): void {
        // clear any tokens stored in cookieStorage
    this.getCognitoCookieKeys().forEach((key) => this.cookieStorage.remove(key));
  }

  public getAllKeys(): string[] {
    return this.getCognitoCookieKeys().map(getFullKeyName);
  }

    /**
     * Get all values stored in cookieStorage by our custom amplifyStorage
     */
  private getCognitoCookieKeys(): string[] {
    return Object.keys(this.cookieStorage.get()).
            filter((key) => key.indexOf(cognitoCookiePrefix) === 0);
  }
}
